import { render, staticRenderFns } from "./Security.vue?vue&type=template&id=635b86a5&scoped=true&"
import script from "./Security.vue?vue&type=script&lang=js&"
export * from "./Security.vue?vue&type=script&lang=js&"
import style0 from "./Security.vue?vue&type=style&index=0&id=635b86a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635b86a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('635b86a5')) {
      api.createRecord('635b86a5', component.options)
    } else {
      api.reload('635b86a5', component.options)
    }
    module.hot.accept("./Security.vue?vue&type=template&id=635b86a5&scoped=true&", function () {
      api.rerender('635b86a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ddv-home/Security.vue"
export default component.exports